export default __webpack_public_path__ + "static/media/cny-flower-2.18934b23.webp";